(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("basic", [], factory);
	else if(typeof exports === 'object')
		exports["basic"] = factory();
	else
		root["SurveyCreatorUIPreset"] = root["SurveyCreatorUIPreset"] || {}, root["SurveyCreatorUIPreset"]["Basic"] = factory();
})(this, () => {
return 